import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UserCard = ({ user, onEdit, onToggleStatus, onViewDetails }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Active':
        return 'bg-success text-success-foreground';
      case 'Inactive':
        return 'bg-muted text-muted-foreground';
      case 'Suspended':
        return 'bg-error text-error-foreground';
      case 'Pending':
        return 'bg-warning text-warning-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getRoleIcon = (role) => {
    switch (role) {
      case 'IT Admin':
        return 'Shield';
      case 'Asset Manager':
        return 'Package';
      case 'Auditor':
        return 'ClipboardCheck';
      case 'Standard User':
        return 'User';
      default:
        return 'User';
    }
  };

  const formatLastLogin = (date) => {
    if (!date) return 'Never';
    const now = new Date();
    const loginDate = new Date(date);
    const diffTime = Math.abs(now - loginDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return 'Today';
    if (diffDays === 2) return 'Yesterday';
    if (diffDays <= 7) return `${diffDays - 1} days ago`;
    return loginDate?.toLocaleDateString();
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-moderate transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
            <span className="text-primary-foreground font-semibold text-lg">
              {user?.name?.split(' ')?.map(n => n?.[0])?.join('')}
            </span>
          </div>
          <div>
            <h3 className="font-semibold text-card-foreground">{user?.name}</h3>
            <p className="text-sm text-muted-foreground">{user?.email}</p>
          </div>
        </div>
        <div className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(user?.status)}`}>
          {user?.status}
        </div>
      </div>
      <div className="space-y-3 mb-4">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Department</span>
          <span className="text-sm font-medium text-card-foreground">{user?.department}</span>
        </div>
        
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Role</span>
          <div className="flex items-center space-x-1">
            <Icon name={getRoleIcon(user?.role)} size={14} className="text-muted-foreground" />
            <span className="text-sm font-medium text-card-foreground">{user?.role}</span>
          </div>
        </div>
        
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Last Login</span>
          <span className="text-sm font-medium text-card-foreground">{formatLastLogin(user?.lastLogin)}</span>
        </div>
        
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Created</span>
          <span className="text-sm font-medium text-card-foreground">
            {new Date(user.createdAt)?.toLocaleDateString()}
          </span>
        </div>
      </div>
      <div className="flex items-center space-x-2 pt-4 border-t border-border">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onViewDetails(user)}
          iconName="Eye"
          iconPosition="left"
          className="flex-1"
        >
          View Details
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onEdit(user)}
          iconName="Edit"
          iconPosition="left"
        >
          Edit
        </Button>
        <Button
          variant={user?.status === 'Active' ? 'outline' : 'default'}
          size="sm"
          onClick={() => onToggleStatus(user)}
          iconName={user?.status === 'Active' ? 'UserX' : 'UserCheck'}
        >
          {user?.status === 'Active' ? 'Suspend' : 'Activate'}
        </Button>
      </div>
    </div>
  );
};

export default UserCard;